import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function ChatbotThreadsLearnMoreModal() {
    return (
        <OnboardingBody title='Engagement bar chatbot threads'>
            <p>Access all chatbot threads from your website directly through the navigation bar.</p>
            <p>
                Explore active, inactive, and unidentified conversations, and review how the bot
                answers questions and helps customers engage with your business.
            </p>
        </OnboardingBody>
    );
}
